export default {
      id: "color_courier-usage",
      viewBox: "0 0 148 189",
      url: __webpack_public_path__ + "sprite.svg#color_courier",
      toString: function () {
        return this.url;
      }
    }